import { useState } from "react";
import { submitContact } from "@/lib/api";

export const ArtworkEnquiry = ({ artwork }) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: `I'm interested in ${artwork.title} and would like to enquire about availability and acquisition.`,
  });
  const [status, setStatus] = useState("idle");

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      await submitContact({
        name: form.name,
        email: form.email,
        phone: form.phone || null,
        message: `Artwork enquiry — ${artwork.title} (${artwork.widthCm} × ${artwork.heightCm} cm)\n\n${form.message}`,
      });
      setStatus("sent");
    } catch (err) {
      console.error("Artwork enquiry failed", err);
      setStatus("error");
    }
  };

  if (status === "sent") {
    return (
      <div data-testid="enquiry-success" className="py-10 text-center">
        <p className="serif text-[24px] text-[#2F2C28]">Thank you.</p>
        <p className="mt-4 text-[16px] leading-[1.8] text-[#2F2C28]">
          Your enquiry about <span className="italic">{artwork.title}</span> has been received. Anissa will reply personally.
        </p>
      </div>
    );
  }

  const field =
    "w-full bg-transparent border-b border-[#D5CDBF] focus:border-[#2F2C28] outline-none py-3 text-[16px] text-[#2F2C28] placeholder-[#8E8B85] transition-colors";

  return (
    <form onSubmit={onSubmit} data-testid="artwork-enquiry-form" className="space-y-8">
      <div>
        <label className="label-eyebrow block">Artwork</label>
        <p className="mt-2 serif italic text-[20px] text-[#2F2C28]" data-testid="enquiry-artwork-title">
          {artwork.title}
        </p>
      </div>
      <div>
        <label htmlFor="enq-name" className="label-eyebrow block">Name</label>
        <input id="enq-name" data-testid="enquiry-name-input" required value={form.name} onChange={set("name")} className={field} autoComplete="name" />
      </div>
      <div>
        <label htmlFor="enq-email" className="label-eyebrow block">Email</label>
        <input id="enq-email" data-testid="enquiry-email-input" required type="email" value={form.email} onChange={set("email")} className={field} autoComplete="email" />
      </div>
      <div>
        <label htmlFor="enq-phone" className="label-eyebrow block">Phone — optional</label>
        <input id="enq-phone" data-testid="enquiry-phone-input" type="tel" value={form.phone} onChange={set("phone")} className={field} autoComplete="tel" />
      </div>
      <div>
        <label htmlFor="enq-message" className="label-eyebrow block">Message</label>
        <textarea id="enq-message" data-testid="enquiry-message-input" required rows={4} value={form.message} onChange={set("message")} className={field} />
      </div>
      {status === "error" && (
        <p data-testid="enquiry-error" className="text-[14px] text-[#A96A53]">
          Something didn't send — please try again, or write via the contact page.
        </p>
      )}
      <button
        type="submit"
        data-testid="enquiry-submit-btn"
        disabled={status === "sending"}
        className="btn-primary disabled:opacity-60"
      >
        {status === "sending" ? "Sending…" : "Send Enquiry"}
      </button>
    </form>
  );
};
